<template>
  <v-footer
    app
    inset
    absolute
    width="auto"
    height="auto"
    :style="style"
    class="text--secondary borderTop"
  >
    <v-row justify="center">
      <v-col class="text-center" cols="12" md="12" sm="8" xs="4"
        >{{ new Date().getFullYear() }} — {{ companyName }}</v-col
      >

      <v-col
        class="text-center"
        cols="12"
        md="12"
        sm="8"
        xs="4"
        v-if="displayCaterpointMessage"
      >
        Powered by
        <strong>Caterpoint</strong> from Caterpoint Systems Ltd
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      companyName: process.env.VUE_APP_COMPANY_NAME,
      displayCaterpointMessage:
        process.env.VUE_APP_DO_NOT_DISPLAY_POWERED_BY_CATERPOINT_MESSAGE ===
        "TRUE"
          ? false
          : true,
      links: [
        {
          name: "Contact Us",
          to: "#",
        },
        {
          name: "Link 2",
          to: "#",
        },
        {
          name: "Link 3",
          to: "#",
        },
      ],
    };
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    style() {
      const Style = {
        background: this.$vuetify.theme.themes[this.theme].footerColor,
      };
      return Style;
    },
  },

  watch: {
    group() {},
  },
};
</script>
